import { jsx as m } from "react/jsx-runtime";
import { f as l } from "../../vendor--aJiswR_.js";
import { forwardRef as r } from "react";
import { stupidInvertClasses as g } from "../../utils/index.js";
import { BaseIcon as p } from "../BaseIcon/index.js";
import { omitStyleRenderProps as u } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index15.css';const d = "_moon_11h5g_1", h = "_red_11h5g_5", i = "_sienna_11h5g_9", f = "_gold_11h5g_13", I = "_cactus_11h5g_17", x = "_green_11h5g_21", b = "_teal_11h5g_25", C = "_blue_11h5g_29", v = "_purple_11h5g_33", R = "_magenta_11h5g_37", j = "_sm_11h5g_41", w = "_md_11h5g_45", y = "_calloutIcon_11h5g_49", o = {
  moon: d,
  red: h,
  sienna: i,
  gold: f,
  cactus: I,
  green: x,
  teal: b,
  blue: C,
  purple: v,
  magenta: R,
  sm: j,
  md: w,
  calloutIcon: y
}, z = {
  sm: "lg",
  md: "xl"
}, q = r(
  ({ icon: s, color: t = "moon", __inverted: _, size: n = "md", ...c }, e) => {
    const a = l(
      o.calloutIcon,
      o[t],
      o[n],
      _ ? g() : void 0
    );
    return /* @__PURE__ */ m(
      p,
      {
        ...u(c),
        "data-component": "CalloutIcon",
        ref: e,
        icon: s,
        size: z[n],
        color: t,
        className: a
      }
    );
  }
);
export {
  q as CalloutIcon
};
//# sourceMappingURL=index.js.map
